var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Daftar Retribusi"},scopedSlots:_vm._u([{key:"toolbar",fn:function(){return [_c('v-btn',{attrs:{"small":"","color":"primary","disabled":_vm.loading},on:{"click":_vm.ImportRetda}},[_vm._v(" Import Retda ")])]},proxy:true}])},[_c('Grid',{staticClass:"dense",staticStyle:{"height":"calc(100vh - 120px)"},attrs:{"datagrid":_vm.users,"dbref":"AST.Retribusi","doRebind":_vm.gridRebind,"columns":[
      {
        name: 'Retribusi',
        value: 'KategoriName',
        width: '250px',
        editable: {
          com: 'Input',
        },
      },
      {
        name: 'Harga',
        value: 'Harga',
        width: '120px',
        editable: {
          com: 'Input',
          type: 'number',
        },
      },
    ]},on:{"update:datagrid":function($event){_vm.users=$event}},scopedSlots:_vm._u([{key:"row-Harga",fn:function({ row }){return [_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("Rp. "+_vm._s(_vm._f("format")(row.Harga)))])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }